import React, { ReactElement, useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import {
  toggleModalFollowList,
  updateUserData,
} from '../profile/slices/profilePageSlice';
import { ResponseFollow } from '../../services/api/models/response/responseFollow';
import { AiOutlineCheck } from 'react-icons/ai';
import { BsPlus } from 'react-icons/bs';
import {
  useGetListFollowMutation,
  useGetListFollowersMutation,
  useGetSelfPersonalDataMutation,
  usePostFollowMutation,
  useUnFollowMutation,
} from '../../services/api/apiProvider';
import './FollowListModal.scss';
import { useHistory } from 'react-router-dom';
import { reproio } from '../../common/utils/reproio';

export interface PropsFollow {
  id?: string;
  title?: string;
}
export interface PropsItemFollow {
  item: ResponseFollow;
}
export const ItemFollow = (props: PropsItemFollow): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [statusFollow, setStatusFollow] = useState<boolean>(
    props.item.followStatus === 'following',
  );
  const [postFollow] = usePostFollowMutation();
  const [unFollow] = useUnFollowMutation();
  const handleChangeFollow = async () => {
    if (statusFollow) {
      await unFollow(props.item.id).unwrap();
      setStatusFollow(!statusFollow);
    } else {
      reproio('track', 'tap follow button');
      await postFollow(props.item.id).unwrap();
      setStatusFollow(!statusFollow);
    }
  };
  const handleRedirectUserProfile = (id?: string) => {
    history.push(`/profile-user/${id}`);
    dispatch(toggleModalFollowList(false));
  };
  return (
    <div key={props.item.id}>
      <div className="user-follow-item">
        <div
          onClick={() => handleRedirectUserProfile(props.item.id)}
          className="user-follow-image"
        >
          <img src={props.item.picture.uri} alt="" />
        </div>
        <div className="user-follow-title">
          <div className="user-follow-name">{props.item.loginId}</div>
          <div className="user-follow-description">
            {props.item.catchPhrase.value}
          </div>
        </div>
        <div onClick={handleChangeFollow} className="user-follow-icon-root">
          {statusFollow ? (
            <div className="user-follow-icon-check">
              <AiOutlineCheck />
            </div>
          ) : (
            <div className="user-follow-icon-plus">
              <BsPlus />
            </div>
          )}
        </div>
      </div>
      <div className="divider"></div>
    </div>
  );
};

export const FollowListModal = (props: PropsFollow): ReactElement => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>();

  const [listFollow, setListFollow] = useState<ResponseFollow[]>();
  const [getListFollows] = useGetListFollowMutation();
  const [getListFollowers] = useGetListFollowersMutation();
  const [getUserData] = useGetSelfPersonalDataMutation();

  const isShowFollowListModal = useSelector(
    (state: AppState) => state.profilePageState.isShowModalFollowList,
  );

  useEffect(() => {
    fetchFollowData();
  }, [props.title]);

  const fetchFollowData = async () => {
    setLoading(true);
    if (!props.title) {
      return;
    }
    if (props.title === 'フォロワー') {
      const data = await getListFollows({ id: props.id }).unwrap();
      setListFollow(data);
    } else {
      const data = await getListFollowers({ id: props.id }).unwrap();
      setListFollow(data);
    }
    setLoading(false);
  };
  const handleCloseModal = async () => {
    const data = await getUserData().unwrap();
    dispatch(updateUserData(data));
    dispatch(toggleModalFollowList(false));
  };

  const renderModal = () => {
    return (
      <Modal
        show={isShowFollowListModal}
        backdrop="static"
        keyboard={false}
        scrollable={true}
        onHide={handleCloseModal}
      >
        <Modal.Header
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          closeButton
        >
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="block-group__loading">
              <Spinner
                animation="border"
                style={{ color: 'var(--color-primary)' }}
              />
            </div>
          ) : (
            <div>
              {listFollow?.map((item: ResponseFollow) => (
                <ItemFollow key={item.id} item={item} />
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  return <>{renderModal()}</>;
};
